import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import usePersistStoreData from "../../Components/Hooks/usePersistStoreData";

import { useDispatch } from "react-redux";
import { showToast } from "../../Components/ToastNotification";
import {
  contractNote_processThunk,
  contractNote_singleThunk,
  contractNote_zipThunk,
  shareEmailReportThunk,
} from "../../slices/thunks";
import CommonLoading from "../../Components/Common/CommonLoading";
import TableContainerDateRangeFilter6 from "../../Components/Common/TableContainerDateRangeFilter6";

import { useSelector } from "react-redux";

const ContractNoteDownload = () => {
  // document.title = "Dashboard | B.N. Rathi";

  const { userData } = usePersistStoreData();
  const dispatch = useDispatch();
  const token = userData?.token;
  const [currentDownloadKey, setCurrentDownloadKey] = useState(null);


  const { contractNote_processData, contractNote_processLoading } =
    useSelector((state) => state.ContractNote_Process);

    const { contractNote_zipData, contractNote_zipLoading } =
    useSelector((state) => state.ContractNote_Zip);

    const handleZipDownload = (selectedName, selectedId) => {
        setCurrentDownloadKey(selectedId);
      dispatch(
        contractNote_zipThunk({
          token,
          params: {
            name: selectedName,

          },
        })
      )
      .unwrap() // if using Redux Toolkit createAsyncThunk; otherwise, chain directly
      .then((result) => {
         // Assume the result is binary data for a zip file.
      // Create a Blob from the response data.
      const blob = new Blob([result], { type: 'application/zip' });
      // Create a URL for the Blob object.
      const downloadUrl = window.URL.createObjectURL(blob);
      // Create a temporary anchor element.
      const link = document.createElement('a');
      link.href = downloadUrl;
      // Append .zip extension if not included in the selectedName.
      const fileName = selectedName.endsWith('.zip') ? selectedName : `${selectedName}.zip`;
      link.setAttribute('download', fileName);
      // Append the link to the document so it becomes part of the DOM.
      document.body.appendChild(link);
      // Programmatically trigger a click on the link to start download.
      link.click();
      // Remove the anchor element from the DOM.
      document.body.removeChild(link);
      // Release the object URL.
      window.URL.revokeObjectURL(downloadUrl);
        showToast("Downloaded successfully.", "success");
      })
      .catch((error) => {
        // console.log("error",error);
        if (error.code === 402) {
          showToast("File not found", "error");
          dispatch(contractNote_processThunk({ token }));
        } else {
          showToast("Something went wrong. Please try again later", "error");
        }
      })
      .finally(() => {
        setCurrentDownloadKey(null); // reset after process
      });
    }
    const handleRefetch = () => {
      dispatch(contractNote_processThunk({ token }));
    } 

  useEffect(() => {
    dispatch(contractNote_processThunk({ token }));
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
            {contractNote_processLoading ? (
              <div
              className="centerContent h-100 w-100"
              style={{ minHeight: "80vh" }}
            >
              <CommonLoading />
            </div>
            ): (
                <Card className="mb-6">
                <CardHeader>
                  <div className="m-0 p-0 d-flex align-items-center justify-content-between">
                    <h3 className="m-0">Contract Note Downloads</h3>
                    <Dropdown
                     
                     className="card-header-dropdown"
                   >
                    
                       <Button type="button" color="primary" className="d-flex align-items-center"
                      onClick={handleRefetch}
                       >
                         Refetch<i className='bx bx-refresh fs-16 ms-2  '></i>

                       </Button>
                     
                     </Dropdown>
                  </div>
                </CardHeader>
                <CardBody className="pb-1 contract_download_container"
                style={{
                    maxHeight:"78vh",
                    overflow:"auto"
                }}
                >
      {contractNote_processData && contractNote_processData.length > 0 ? (
      contractNote_processData.map((item, index) => (
        <div
          key={item.id}
          className={`centerContent mb-3 p-2  ${index === contractNote_processData.length - 1 ? "" : "border-bottom"}`}
        >
          {/* Serial number */}
         

          {/* Name and Progress */}
          <div className="flex-grow-1 me-3">
          <div className="d-flex align-items-center mb-1 ">
              {/* Serial number */}
              <span className="me-2 text-muted fs-14 fw-medium">
               {index + 1}.
              </span>
              {/* Title */}
              <span className="text-dark fs-14 fw-medium">{item.name}</span>
            </div>
            <div className="progress" style={{  }}>
              <div
                className="progress-bar progress-bar-striped progress-bar-animated"
                role="progressbar"
                style={{
                  width: `${item.progress}%`,
                }}
                aria-valuenow={item.progress}
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
          </div>

          {/* Download Button */}
          {item.progress === 100 && (
             <div>
             <Button type="button" size="sm" color="success"
             onClick={() => {
                 handleZipDownload(item.name, item?.id)
             }}
             style={{
                minWidth:"105px",
             }}
             disabled={currentDownloadKey === item.id && contractNote_zipLoading}
             >
               {currentDownloadKey === item.id && contractNote_zipLoading
                 ? <Spinner size="sm" />
                 : "Download"}
               <i className="bx bx-download fs-16 ms-2"></i>
             </Button>
           </div>
          )}
          
        </div>
        ))
        ) : (
            <Card className="m-0 text-muted"
            style={{
              maxHeight:"78vh"
            }}
            >
            <CardBody className="d-flex justify-content-center">No Record Found</CardBody>
          </Card>
      )}
    </CardBody>
              </Card>
            )}
          
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ContractNoteDownload;
